<main role="main" class="col-12" [ngClass]="{'pl-menu': !navbar}">
    <h5 class="mt-2">REPORTE DE INCIDENCIAS</h5>
    <app-lista-incidencias></app-lista-incidencias>
</main>